document.addEventListener("DOMContentLoaded", function () {
  const languageList = document.querySelectorAll(".pll-language-list");

  // Перевірка, чи є цей елемент
  if (languageList) {
    languageList.forEach((item) => {
      item.addEventListener("click", function () {
        item.classList.toggle("active");
      });
    });
  }
});
